export interface SubmitResult {
  ok: boolean;
  message: string;
}

interface FormResponse {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
}

const GUARD_FIELD = "website_alt";

export async function submitReaddyForm(
  action: string,
  form: HTMLFormElement,
  successFallback: string,
): Promise<SubmitResult> {
  const raw = new FormData(form);

  const guard = String(raw.get(GUARD_FIELD) ?? "").trim();
  if (guard) {
    return { ok: true, message: successFallback };
  }

  const payload = new URLSearchParams();
  raw.forEach((value, key) => {
    if (key === GUARD_FIELD) return;
    if (value instanceof File) return;
    const text = String(value);
    if (text.trim() === "") return;
    payload.append(key, text);
  });

  try {
    const response = await fetch(action, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: payload.toString(),
    });

    const responseText = await response.text();
    let parsed: FormResponse | null = null;
    try {
      parsed = JSON.parse(responseText) as FormResponse;
    } catch {
      parsed = null;
    }

    const serverMsg =
      parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText;

    if (response.ok && parsed?.code === "OK") {
      return { ok: true, message: serverMsg || successFallback };
    }

    if (typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam")) {
      return { ok: false, message: serverMsg };
    }

    return { ok: false, message: serverMsg || "提交失败，请稍后再试。" };
  } catch {
    return { ok: false, message: "网络异常，请稍后再试。" };
  }
}